import React, { useState } from 'react';
import { projects } from '../data/mock';
import { ProjectCard } from '../components/projects/ProjectCard';
import ScrollReveal, { StaggerContainer, StaggerItem } from '../components/ui/ScrollReveal';

const ProjectsPage = () => {
  const [filter, setFilter] = useState('All');

  const filters = ['All', 'Product Development', 'Offshore Development'];

  const filteredProjects = filter === 'All'
    ? projects
    : projects.filter(p => p.type === filter);

  return (
    <div className="min-h-screen bg-slate-950">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16">
        {/* Background Effects */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-teal-500/10 rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <ScrollReveal animation="fadeDown" delay={0.1}>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                Complete Project{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">
                  Portfolio
                </span>
              </h1>
            </ScrollReveal>
            <ScrollReveal animation="fadeUp" delay={0.2}>
              <p className="text-xl text-slate-400 leading-relaxed">
                Explore our comprehensive collection of mobile applications and web platforms,
                showcasing innovation across diverse industries.
              </p>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Filter Tabs */}
      <ScrollReveal animation="fadeUp" delay={0.3}>
        <section className="relative pb-8">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-3">
              {filters.map((item) => (
                <button
                  key={item}
                  onClick={() => setFilter(item)}
                  className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 ${filter === item
                    ? 'bg-emerald-500 text-slate-900 shadow-lg shadow-emerald-500/20'
                    : 'bg-slate-800/50 text-slate-300 hover:bg-slate-800 hover:text-white border border-slate-700/50'
                    }`}
                >
                  {item}
                </button>
              ))}
            </div>
          </div>
        </section>
      </ScrollReveal>

      {/* Projects Grid - Zig Zag Animation */}
      <section className="relative py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="space-y-8">
            {filteredProjects.map((project, index) => (
              <ScrollReveal
                key={project.id}
                animation={index % 2 === 0 ? "fadeRight" : "fadeLeft"}
                delay={0.1}
              >
                <div className={`flex ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                  <div className="w-full md:w-2/3 lg:w-1/2">
                    <ProjectCard project={project} />
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          {/* Pagination - Visual Only */}
          <ScrollReveal animation="fadeUp" delay={0.4}>
            <div className="flex justify-center items-center gap-2 mt-16">
              {[1, 2, 3].map((num) => (
                <button
                  key={num}
                  className={`w-10 h-10 rounded-full text-sm font-medium transition-all duration-300 ${num === 1
                    ? 'bg-emerald-500 text-slate-900'
                    : 'bg-slate-800/50 text-slate-400 hover:bg-slate-800 hover:text-white border border-slate-700/50'
                    }`}
                >
                  {num}
                </button>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
};

export default ProjectsPage;
